import React from 'react'
import {
  Product,
  useEventProducts,
} from 'organization/Event/Products/EventProductsProvider'
import styled from 'styled-components'
import {confirmAlert} from 'react-confirm-alert'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import {useI18n} from 'i18n/I18nContext'

export const ListProduct = (props: {
  product: Product
  index: number
  onEdit: (product: Product) => void
}) => {
  const {product, index, onEdit} = props
  const {t} = useI18n()

  const {deleteProduct, loading} = useEventProducts()

  const removeProduct = () => {
    confirmAlert({
      message: t('orgProduct.deleteConfirm').replace('{name}', product.name),
      buttons: [
        {
          label: t('common.yes'),
          onClick: async () => {
            deleteProduct(product)
          },
        },
        {
          label: t('common.no'),
          onClick: () => {
            // nothing
          },
        },
      ],
    })
  }

  return (
    <tr key={index}>
      <CenteredTD> {product.id} </CenteredTD>
      <CenteredTD>{product.name} </CenteredTD>
      <CenteredTD>{product.price} €</CenteredTD>
      <CenteredTD>{product.sales}</CenteredTD>
      <CenteredTD>
        {product.status === true && (
          <span className={'status__tag bg-green'}>
            <span>{t('orgProduct.active')}</span>
          </span>
        )}

        {product.status === false && (
          <span className={'status__tag warning-bg'}>
            <span>{t('orgProduct.inactive')}</span>
          </span>
        )}
      </CenteredTD>
      <CenteredTD style={{width: '250px'}}>
        <ButtonsHolder>
          <button
            className={loading ? 'disableBtnStyle' : 'input__btn'}
            onClick={() => {
              onEdit(product)
            }}
          >
            {t('orgProduct.edit')}
          </button>

          <button
            className={loading ? 'disableBtnStyle' : ''}
            onClick={removeProduct}
          >
            <HighlightOffIcon color="warning" fontSize="large" />
          </button>
        </ButtonsHolder>
      </CenteredTD>
    </tr>
  )
}

const CenteredTD = styled.td`
  text-align: center;
`

const ButtonsHolder = styled.div`
  display: flex;
  justify-content: space-between;
`
